// extracted by mini-css-extract-plugin
module.exports = {"content":"SecurityNews_content__9ad2r","title":"SecurityNews_title__3wous","source":"SecurityNews_source__3BlWC"};